import { RolesHeaders } from '../../../utils/headers';
import ActionsMenu from '../components/ActionsMenu';
import DataTable from '../../../components/Table/DataTable';
import SearchToolbar from '../../../components/SearchToolbar/SearchToolbar';
import useRoles from './hooks/useRoles';
import RoleDrawerShow from './RolesShow/RoleDrawerShow';
import RoleDrawerSave from './RolesSave/RoleDrawerSave';

function RolesIndex() {
    const {
        roles,
        anchorEl,
        btnSelectStyle,
        filterModelValue,
        loadingRoles,
        fetchingRoles,
        deletingRole,
        handleOpenDrawer,
        onInputChange,
        handleMenuAction,
        handleCloseMenu,
        handleSubmitAction,
        ...props
    } = useRoles();
    return (
        <>
            <SearchToolbar
                inputLabel="Buscar"
                btnText="Nuevo rol"
                onButtonClick={() => handleOpenDrawer('new')}
                onInputChange={onInputChange}
            />
            <DataTable
                headers={RolesHeaders}
                handleMenuAction={handleMenuAction}
                withActions={['menu']}
                loading={loadingRoles || fetchingRoles || deletingRole}
                options={roles}
                filterModelValue={filterModelValue}
                customStyles={{
                    [`${btnSelectStyle}`]: {
                        background: '#E2ECF3',
                        borderRadius: '2px !important'
                    }
                }}
            />
            <ActionsMenu
                anchorEl={anchorEl}
                handleCloseMenu={handleCloseMenu}
                handleSubmitAction={handleSubmitAction}
            />

            <RoleDrawerSave {...props} />

            <RoleDrawerShow {...props} />
        </>
    );
}

export default RolesIndex;
